/* eslint-disable no-shadow */
export enum GameStatus {
    WON = 'WON',
    LOST = 'LOST',
    TIE = 'TIE',
    RESERVED = 'RESERVED',
    AVAILABLE = 'AVAILABLE',
}